const DEEP_LINKS = {
  openApp: '/app', // universal link — opens native app if installed, falls back to store via Temporary
};

export { DEEP_LINKS };
